import React from "react";
import classNames from "classnames";
import { FileDropzone } from "@design-system/FileDropzone/FileDropzone";
import { ChildrenProps } from "../../../types";
import { useFinancialDocumentUpload } from "./useFinancialDocumentUpload";
import styles from "./FinancialDocumentUploadDropzone.module.scss";

interface FinancialDocumentUploadDropzoneProps extends ChildrenProps {
    dropzoneClassName?: string;
    coverClassName?: string;
    cover?: React.ReactNode;
}

export const FinancialDocumentUploadDropzone: React.FC<
    FinancialDocumentUploadDropzoneProps
> = ({ children, cover, coverClassName, dropzoneClassName }) => {
    const { isDragActive, rootProps } = useFinancialDocumentUpload();

    return (
        <FileDropzone
            rootProps={rootProps}
            isDragActive={isDragActive}
            cover={cover}
            coverClassName={classNames(styles.cover, coverClassName)}
            className={dropzoneClassName}
            data-testid="financial-documents-dropzone"
        >
            {children}
        </FileDropzone>
    );
};
